var staticLocation = require('./staticLocation')

function helperGetLocatOrigin () {
  return staticLocation ? (staticLocation.origin || (staticLocation.protocol + '//' + staticLocation.host)) : ''
}

module.exports = helperGetLocatOrigin



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetLocatOrigin.js
// module id = OyZx
// module chunks = 137